import { storeMixin } from '@/storeMixin'
import { merge } from 'lodash'

const roleCommonFilter = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/contact-role',
    app: 'organization',
    pk: 'code'
  }
})

const TYPES = {
  ROLE_COMMON_FILTER: {
    LIST: {
      GETTERS: {
        filters: 'commonFilters/roleCommonFilter/filters',
        list: 'commonFilters/roleCommonFilter/list'
      },
      MUTATIONS: {
        setFilters: 'commonFilters/roleCommonFilter/setFilters',
        setList: 'commonFilters/roleCommonFilter/setList'
      },
      ACTIONS: {
        getList: 'commonFilters/roleCommonFilter/getList',
        setFilters: 'commonFilters/roleCommonFilter/setFilters'
      }
    }
  }
}

export { roleCommonFilter, TYPES }
